import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";

import ShipmentForm from "./ShipmentComponents/ShipmentForm";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useAddShipmentMutation } from "store/services/shipmentApi";

import { useAppMeta, useAuth } from "hooks";

const ShipmentCreateScreen = () => {
  const { isVendor } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isCollect = searchParams.get("collect") === "true"; 
  const basePath = isVendor ? "/app/vendor/shipment" : "/app/crm/shipment";

  const breadcrumbs = [
    {
      title: "Shipment",
      path: isVendor ? "/app/vendor/shipment/list" : "/app/crm/shipment/list",
    },
    {
      title: isCollect ? "Add & Collect" : "Create",
      path: "",
    },
  ];

  const [createShipment, { isLoading: creatingShipment }] =
    useAddShipmentMutation();

  // Methods
  const handleAddShipment = async (data) => {
    try {
      const payload = {
        ...data,
        ...(isCollect && {
          collectionData: {
            actualPickupTime: new Date().toISOString(), 
            status: "Completed", 
          },
        }),
      };
const { shipment: { _id } } = await createShipment(payload).unwrap();      toast.success(
        isCollect ? "Shipment Created and Collected!" : "Shipment Created!"
      );
      navigate(`${basePath}/${_id}/detail`);
    } catch (error) {
      toast.error(
        error?.data?.message ?? error.message ?? "Could not create shipment!"
      );
    }
  };

  useAppMeta(isCollect ? "New Shipment & Collection" : "New Shipment");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingShipment}>
      <BreadcrumbLayout.Paper>
        <ShipmentForm
          isBusy={creatingShipment}
          onSubmit={handleAddShipment}
          isCollect={isCollect}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default ShipmentCreateScreen;